import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store'

export const usePageTitle = (stageTitle: string) => {
  const programName = useSelector((state: RootState) => state.program.data?.name)
  const institutionName = useSelector((state: RootState) => state.institution.data?.name)

  useEffect(() => {
    if (!programName) return

    const suffix = institutionName ? `Feripro ${institutionName}` : 'Feripro'
    document.title = `${programName}: ${stageTitle} | ${suffix}`
  }, [programName, stageTitle, institutionName])
}

export default usePageTitle
